<div class="clipped-circle-spinner">
  <div class="la-ball-clip-rotate">
    <div></div>
  </div>
</div>